
import React, { Component } from 'react'
// import 'jquery.scrollto';
import './index-css.css'


class Disable extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount(){

    }

    render() { 
        return (
            <div className='m-Disable'>
                <div className='wrapper'>
                    <i className='icon'></i>
                    <div className='text'>为了更好的体验，请使用竖屏浏览</div>
                </div>
            </div>
         );
    }
}
 
export default Disable;